// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reference-violation-types__list[data-v-0361f490] {\n  max-width: 1190px;\n}\n.reference-violation-types__list__without-group[data-v-0361f490] {\n    margin-top: 20px;\n}\n.sortable__ghost[data-v-0361f490] {\n  padding: 0 !important;\n  height: 0 !important;\n  min-height: 0;\n  border: 5px solid #0066ff !important;\n  border-radius: 3px;\n  content-visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
